import type { LabeledGraphicSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

const PointStyled = styled.div<{ $styles: ElementStyleCss<LabeledGraphicSchemaType> }>`
  position: relative;
`

export default PointStyled
